import { createAuthLink } from "aws-appsync-auth-link";
import { createSubscriptionHandshakeLink } from "aws-appsync-subscription-link";
import {
  ApolloProvider,
  ApolloClient,
  InMemoryCache,
  HttpLink,
  ApolloLink,
} from "@apollo/client";
import { Auth } from "aws-amplify";
import AppSync from "./AppSync.js";

const {
  region,
  graphqlEndpoint: url,
  authenticationType: type,
  apiKey,
} = AppSync;

const auth = {
  type,
  apiKey,
  jwtToken: async () => {
    try {
      return (await Auth.currentSession()).getIdToken().getJwtToken();
    } catch (error) {
      // Session expired or invalid - sign out and redirect to login
      console.error("Failed to get current session:", error);
      await Auth.signOut();
      window.location.href = "/";
      throw error; // Re-throw to prevent the GraphQL request
    }
  },
};

const httpLink = new HttpLink({ uri: url });

const link = ApolloLink.from([
  createAuthLink({ url, region, auth }),
  createSubscriptionHandshakeLink({ url, region, auth }, httpLink),
]);

const client = new ApolloClient({
  link,
  cache: new InMemoryCache({
    typePolicies: {
      User: {
        keyFields: ["sub"],
      },
    },
  }),
});

export const AppSyncApolloProvider = ({ children }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
